<template>
  <footer id="site-footer">
    <div class="site-footer-inner container">
      <div class="pref-list-wrapper">
        <h2 class="pref-heading">
          都道府県からセミナー会場を探す
        </h2>
        <kcs-footer-pref-list />

        <h2 class="type-heading">
          駅・路線からセミナー会場を探す
        </h2>
        <kcs-footer-line-list />
      </div>
      <div class="site-info">
        <h2 class="type-heading">イベントの規模・種類から探す</h2>
        <ul class="type-list">
          <li
            v-for="(eventType, index) in eventTypesList"
            :key="index"
            class="region"
          >
            <nuxt-link :to="eventType.url">{{ eventType.title }}</nuxt-link>
          </li>
        </ul>

        <h2 class="type-heading">施設の種類から探す</h2>
        <ul class="type-list">
          <li
            v-for="(facilityType, index) in facilityTypesList"
            :key="index"
            class="region"
          >
            <nuxt-link :to="facilityType.url">
              {{ facilityType.title }}
            </nuxt-link>
          </li>
        </ul>

        <p class="site-logo">
          <img
            src="/images/logo.svg"
            class="site-logo"
            alt="こくちーずスペース"
          />
        </p>
        <ul class="footer-nav">
          <li><nuxt-link to="/gp/about/">こくちーずスペースとは</nuxt-link></li>
          <li><nuxt-link to="/summary/">イベント会場まとめ</nuxt-link></li>
          <li><a href="/help/" target="_blank">ヘルプ</a></li>
          <li><nuxt-link to="/gp/terms/">利⽤規約</nuxt-link></li>
          <li><a :href="companyPageUrl" target="_blank">運営会社</a></li>
          <li><a href="/contact/" target="_blank">お問い合わせ</a></li>
          <li>
            <a href="/request/" target="_blank">掲載リクエストフォーム</a>
          </li>
        </ul>
      </div>
    </div>
    <p class="copyright">&copy; こくちーずスペース</p>
  </footer>
</template>

<script>
import { createUrl } from '@/utils/create-url'
import { methods } from '@/utils/methods'
import KcsFooterPrefList from '@/components/molecules/kcs-footer-pref-list.vue'
import KcsFooterLineList from '@/components/molecules/kcs-footer-line-list.vue'
export default {
  components: {
    KcsFooterPrefList,
    KcsFooterLineList
  },
  computed: {
    eventTypesList() {
      const facilityEventTypesList = methods.getFacilityEventTypesList()
      return facilityEventTypesList.map((facilityEventTypes) => {
        return {
          title:
            facilityEventTypes.searchTitle +
            '【' +
            facilityEventTypes.searchSubTitle +
            '】',
          url: createUrl.createSearchUrl({
            eventType: [facilityEventTypes.value]
          })
        }
      })
    },
    facilityTypesList() {
      const facilityTypeList = methods.getFacilityTypeList()
      return facilityTypeList.map((facilityType) => {
        let title = facilityType.name + 'のセミナー会場を探す'
        if (
          ['6', '7', '8', '9', '10', '11', '12', '13', '14', '15'].includes(
            facilityType.value
          )
        ) {
          title = 'イベントで使える' + facilityType.name + 'を探す'
        }
        return {
          title,
          url: createUrl.createSearchUrl({
            facilityType: [facilityType.value]
          })
        }
      })
    },
    companyPageUrl() {
      return process.env.COMPANY_PAGE
    }
  }
}
</script>
